<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sigilnotintoc1" id="pgepubid00008">ILLUSTRATIONS</h2>
<p class="calibre5"><a href="#/Text/Section0001.htm#illus01"><span class="smcap">Colonel F.L. Morrison, C.B., D.S.O., V.D.</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0005.htm#illus03"><span class="smcap">Officers of the Battalion, July 1914</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0006.htm#illus04"><span class="smcap">Cape Helles, Gallipoli</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0006.htm#illus05"><span class="smcap">Gully Ravine, Cape Helles</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0010.htm#illus08"><span class="smcap">Suez Canal at Ballah</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0011.htm#illus09"><span class="smcap">In a Redoubt, Mahamdiya</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0011.htm#illus10"><span class="smcap">Water Camels, Mahamdiya</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0011.htm#illus11"><span class="smcap">Sheikh's Tomb, Katia</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0011.htm#illus12"><span class="smcap">Bivouacs, El Rabah</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0012.htm#illus13"><span class="smcap">Camel Lines, El Arish</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0012.htm#illus14"><span class="smcap">Baggage Camels on Shore near El Arish</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0013.htm#illus15"><span class="smcap">Mouth of Wadi El Arish</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0013.htm#illus16"><span class="smcap">Bedouin Sheikhs, Belah</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0013.htm#illus17"><span class="smcap">Bedouins, Khan Yunis</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0014.htm#illus18"><span class="smcap">Typical Small Nullah near Wadi Ghuzzee</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0014.htm#illus19"><span class="smcap">Native Girls, Belah</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0015.htm#illus20"><span class="smcap">Inside Yapton Post</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0015.htm#illus21"><span class="smcap">Sheikh Abbas</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0015.htm#illus22"><span class="smcap">Observation Post in front of Yapton Post</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0016.htm#illus23"><span class="smcap">Sausage Ridge, Deir Sineid</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0016.htm#illus25"><span class="smcap">Orange Sellers, Mejdel</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0016.htm#illus26"><span class="smcap">Berfylia</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0017.htm#illus28"><span class="smcap">Jaffa from the Shore</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0018.htm#illus29"><span class="smcap">In Sarona</span></a><br class="calibre1"/></p>
<h2 class="sigilnotintoc1 sigil_not_in_toc" id="pgepubid00009">MAPS</h2>
<p class="calibre5"><a href="#/Text/Section0008.htm#illus06"><span class="smcap">Gallipoli—Battle of 12th July, 1915</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0009.htm#illus07"><span class="smcap">Sketch to Illustrate Position on Night of 19-20th<br class="calibre1"/>
  December, 1915</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0016.htm#illus24"><span class="smcap">Area of Operations 7-8th November, 1917</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0016.htm#illus27"><span class="smcap">Sketch showing Route taken by the Battalion between<br class="calibre1"/>
  Gaza and Jaffa, November-December, 1917</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0019.htm#illus30"><span class="smcap">Area of Operations 24-27th August, 1918</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0019.htm#illus31"><span class="smcap">Moeuvres, September, 1918</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0023.htm#illus34a"><span class="smcap">Gallipoli and the Dardanelles, Bird's-Eye View</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0023.htm#illus36a"><span class="smcap">Northern Portion of Sinai Peninsula</span></a><br class="calibre1"/>
<br class="calibre1"/>
<a href="#/Text/Section0023.htm#illus35a"><span class="smcap">Gaza</span></a><br class="calibre1"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?4e56930f